/// <amd-module name="SuiteCommerce.GridOrder.Footer.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Footer.View", ["require", "exports", "underscore", "Backbone", "grid_order_footer.tpl", "SuiteCommerce.GridOrder.Configuration"], function (require, exports, _, Backbone_1, footerTemplate, GridOrder_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var FooterView = /** @class */ (function (_super) {
        __extends(FooterView, _super);
        function FooterView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = footerTemplate;
            _this.quantitiesByColumn = options.quantitiesByColumn;
            _this.container = options.container;
            return _this;
        }
        FooterView.prototype.updateQuantities = function (quantitiesByColumn) {
            this.quantitiesByColumn = quantitiesByColumn;
        };
        FooterView.prototype.getContext = function () {
            return {
                quantitiesByColumn: _.values(this.quantitiesByColumn),
                quantitySummaryLabel: GridOrder_Configuration_1.GridOrderConfiguration.quantitySummaryLabel,
            };
        };
        return FooterView;
    }(Backbone_1.View));
    exports.FooterView = FooterView;
});
